import type { ExperimentKey, SetsExperimentDef } from '../types';
import { experiment as setBuilderLab } from './set-builder-lab';
import { experiment as powerSet } from './power-set';
import { experiment as cartesianProduct } from './cartesian-product';
import { experiment as relations } from './relations';
import { experiment as equivalencePartition } from './equivalence-partition';
import { experiment as functions } from './functions';
import { experiment as numberSystems } from './number-systems';

export const EXPERIMENTS: Record<string, SetsExperimentDef> = {
  'set-builder-lab': setBuilderLab,
  'power-set': powerSet,
  'cartesian-product': cartesianProduct,
  relations,
  'equivalence-partition': equivalencePartition,
  functions,
  'number-systems': numberSystems,
};

export const EXPERIMENT_ORDER: ExperimentKey[] = [
  'set-builder-lab',
  'power-set',
  'cartesian-product',
  'relations',
  'equivalence-partition',
  'functions',
  'number-systems',
];
